export default {
  apiKey: "AIzaSyDpXrNzUty4cKy2QSvAw1i2bMXxMOvbSEU",
  authDomain: "xtraire-18mi.firebaseapp.com",
  projectId: "xtraire-18mi",
  storageBucket: "xtraire-18mi.appspot.com",
  messagingSenderId: "31593020496",
  appId: "1:31593020496:web:bed413cf0da415052ee555"
};
